import { css } from '@emotion/react'
import { Heading, Spinner, Theme, useTheme } from 'bold-ui'

export function VideochamadaReconnectOverlay() {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <output css={styles.container}>
      <Spinner size={3} borderWidth={4} style={styles.spinner} />
      <Heading level={2} style={styles.heading}>
        Conexão perdida. Estamos tentando reconectar, não feche esta página.
      </Heading>
    </output>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    text-align: center;
  `,
  spinner: css`
    color: ${theme.pallete.gray.c100};
  `,
  heading: css`
    color: ${theme.pallete.gray.c100};
  `,
})
